<template>
    <van-popup position="right" :style="{ height: '100%',width:'100%'}"  v-model="show_stu_list">
        <div class="popup-head" @click="close_stu_popup">
            <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="popup-content-box">
            <p>选择学生 <span>{{sure_stu_list.length}}/{{class_stu_list.length}}</span></p>
            <div class="content-content-button">
                <span v-for="(item,index) in class_stu_list" :class="{active:item.check}" @click="change_stu_list(item,index)">{{item.username}}</span>
            </div>
            <div class="bottom-bottom">
                <span @click="sure_check_stu">确定</span>
            </div>
        </div>
    </van-popup>

</template>

<script>
    export default {
        name: "addModel",
        props:{
            allStuList:{
                type:Array,
                default() {
                    return [];
                }
            } ,
            selectList:{
                type:Array,
                default() {
                    return [];
                }
            },
            showTitle:{

            }
        },
        data(){
            return{
                show_stu_list:true,
                sure_stu_list:_.cloneDeep(this.selectList),//弹窗中选择的学生
                class_stu_list:_.cloneDeep(this.allStuList),

                show_class_input:false,//班级名称输入框
                class_name_input:'',//班级名称
                class_name_input_s:'',
            }
        },
        created() {

        },
        methods:{
            //
            showClassInput(){
                this.show_class_input = true;
                this.class_name_input =  this.class_name_input_s ;
            },
            //关闭学生列表
            close_stu_popup(){
                this.show_stu_list = false;
                this.$emit('closeStuList',{
                    selsect_data:this.selectList,
                    is_close:true
                })
            },
            //点击确定学生列表
            sure_check_stu(){
                this.show_stu_list = false;
                // this.cur_stu_list =  _.cloneDeep( this.sure_stu_list);
                this.$emit('closeStuList',{
                    selsect_data:this.sure_stu_list,
                    is_close:false
                })
            },
            change_stu_list(item,index){
                //当前是否选中-》选中-》判断是否上一次指定
                if (!item.check) {
                    item.check = !item.check;
                    this.sure_stu_list.push(item.id);
                } else {
                    item.check = !item.check;
                    let cur_index = this.sure_stu_list.indexOf(item.id);
                    this.sure_stu_list.splice(cur_index, 1);
                }
                // this.filter_total_price();
            },
        },
        watch:{
            selectList:{
                handler(newVal,oldVal){

                },
                deep:true,
                immediate:true
            }
        },
    }
</script>

<style scoped lang="scss">
    .item-item-box{
        background: #fff;
        padding: 0 0.1rem;
        overflow: hidden;
        border-bottom: 1px solid #0000001a;
        height: 0.44rem;
        line-height: 0.44rem ;
    }
    .item-left{
        //padding-left: 0.1rem;
        float: left;
        color:#7b6e6e;
        i{
            color:red;
            font-style: normal;
            vertical-align: middle;
        }
        span{
            vertical-align: middle;
        }
    }
    .item-right{
        float: right;
    }
    .van-popup--right{
        background: #F1F2F4;
    }
    .popup-head{
        background: #fff;
        line-height: 0.4rem;
        height: 0.4rem;
        @include fz_color;
        padding:0 0.1rem;
    }
    .popup-content-box{
        padding-top:0.1rem;
        height: calc(100% - 0.4rem);
        p{
            padding:0 0.1rem 0 0.24rem;
            line-height: 0.42rem;
            height: 0.42rem;
            span{
                float: right;
            }
        }
        .bottom-bottom{
            padding: 0.2rem 0;
            text-align: center;
            span{
                display: inline-block;
                float: none;
                background: #027BFE;
                color:#fff;
                width: 2.9rem;
                height: 0.4rem;
                line-height: 0.4rem;
                text-align: center;
                border-radius:4px;
            }
        }
    }
    .content-content-button{
        max-height: calc(100% - 1.3rem);
        background: #fff;
        /*overflow: auto;*/
        padding:0.15rem 0.1rem;
        span{
            line-height: 0.3rem;
            margin: 0 0.1rem 0.15rem 0.1rem;
            display: inline-block;
            padding:0 0.1rem;
            background:rgba(255,255,255,1);
            border-radius:15px;
            border:1px solid rgba(0,0,0,0.25);
            &.active{
                color:#fff;
                background: #2B99FF;
                border-color: #2B99FF;
            }
        }
    }

</style>